import { CommonService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const UkVehicleDataLookupQueryKey = 'UkVehicleDataLookupQueryKey';

export type UkVehicleDataLookupFilter = {
  vrm?: string;
};

export const useUkVehicleDataLookupQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  filter: UkVehicleDataLookupFilter,
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof CommonService.getCommonVehicleData>>,
      QueryError,
      Awaited<ReturnType<typeof CommonService.getCommonVehicleData>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    [UkVehicleDataLookupQueryKey, ...(queryKey ?? [{ ...filter }])],
    () => CommonService.getCommonVehicleData(filter.vrm),
    options
  );
